import { Component, Input, OnChanges } from '@angular/core';
import { DomHelper, HorizontalListData, MessageService } from 'common';
import { ApplicationProfileComponentData } from '../application-profile/application-profile.component';
import { ApplicationStatusWidgetAdapter } from './application-status-widget.data';

@Component({
    selector: 'ifb-application-status-widget',
    templateUrl: './application-status-widget.component.html',
    styleUrls: ['./application-status-widget.component.scss'],
    providers: [ApplicationStatusWidgetAdapter],
    standalone: false
})
export class ApplicationStatusWidgetComponent implements OnChanges{
  @Input()
  data: ApplicationProfileComponentData;

  listItems: HorizontalListData[];

  constructor(
    private readonly adapter: ApplicationStatusWidgetAdapter,
    private readonly messageService: MessageService,
  ) {}

  ngOnChanges(): void {
    this.listItems = this.adapter.adaptListData(this.data);
  }

  copy(value: string): void {
    DomHelper.copy(value);
    this.messageService.info('Link copied');
  }
}
